import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDoc from "../../../modules/SimpleDoc";

class SimpleUploadExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      data: null,
    };
  }

  changeInput = (fileName, file) => {
    if (file) {
      this.setState({ data: file });
    }
  };

  validateInput = async () => {
    const { data } = this.state;
    const { onChange, onClickClose } = this.props;

    if (!data) {
      this.showError();
      return;
    }

    try {
      // Panggil onChange dari parent tanpa memicu popup global
      const result = await onChange(data);

      const component = document.getElementById("inputFile");
      if (component && component.value) component.value = "";

      if (!result) {
        this.showError();
        return;
      }

      onClickClose();
    } catch (err) {
      console.error("Error saat upload file:", err);
      this.showError();
    }
  };

  showError = () => {
    this.setState((prev) => ({ error: !prev.error }));
  };

  handleDownloadErrorLog = async () => {
    const { onDownloadLogError } = this.props;
    const { data } = this.state;

    if (!data) {
      alert("Tidak ada file untuk diunduh log error.");
      return;
    }

    try {
      if (onDownloadLogError) {
        // Tangani error sendiri di dalam fungsi ini, tidak memanggil setError global
        await onDownloadLogError(data);
      }
    } catch (err) {
      console.error("Gagal download log error:", err);
      alert("Terjadi kesalahan saat download log error. Cek console.");
    }
  };

  render() {
    const { visible, onClickClose, onDownloadTemplate, downloadError } = this.props;
    const { error, data } = this.state;

    return (
      <>
        <SimpleModal
          title="Upload Part Detail Data"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              {/* Unduh Template */}
              <FlexView vAlignContent="center" className="margin-bottom-20px">
                <div className="margin-5px">
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>Template file dapat diunduh</h4>
                  </div>
                </div>
                <SimpleButton text="DISINI" onClick={onDownloadTemplate} />
              </FlexView>

              {/* Upload File */}
              <FlexView vAlignContent="center" className="margin-bottom-20px margin-top-20px">
                <SimpleDoc readOnly idInputFile="inputFile" onChange={this.changeInput} />
              </FlexView>

              {/* Tombol Validasi */}
              <FlexView hAlignContent="right" className="margin-bottom-20px margin-top-20px">
                <SimpleButton styles={{ width: "250px" }} onClick={this.validateInput} disabled={!data}>
                  Validasi & Upload File
                </SimpleButton>
              </FlexView>
            </ModalContainer>
          }
        />

        {/* --- Alert Error --- */}
        {error && (
          <SimpleAlert
            title="Gagal Upload Data!"
            visible={error}
            onClickClose={this.showError}
            content="Terdapat kesalahan pengisian data upload. Mohon diperbaiki dan upload kembali kemudian!"
            additionalButtons={
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <SimpleButton secondary onClick={this.showError}>
                  Tutup
                </SimpleButton>
                {downloadError && (
                  <SimpleButton onClick={this.handleDownloadErrorLog}>Download Error Log</SimpleButton>
                )}
              </div>
            }
          />
        )}
      </>
    );
  }
}

export default SimpleUploadExcel;
